import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import MyCourseActionTypes from './myCourse.types';
import UserProfileTypes from '../userDetails/userDetails.actionTypes';
import ProfileTypes from '../profile/profile.types';
import TestPageActionTypes from '../testPage/testPage.types';
import { UPDATE_ACTIVE_COURSE } from '../userAuthentication/userAuth.actionTypes';
import UtilsTypes from '../utilities/utils.types';
import {
	getCourseId,
	getScheduleId,
	getSelectedFile,
	getReason,
	getCancelScheduleId,
	getQueryElementId,
	getGrade,
} from './myCourse.selectors';
import { appendScript } from '../../utils/appendScript';
import Loader from '../../utils/Loader';
import {
	clearLocalStorage,
	getParameterByName,
} from '../../utils/commonFunctions';
import {
	getChildToken,
	getChildDetails,
	getActiveChild,
} from '../parentDashboard/parentDashboard.selector';
import { getUserType } from '../userAuthentication/userAuth.selectors';
import UserTypes from '../../utils/userTypes';
import { RPStart } from '../../utils/supervisor';

function* setError(msg, showBtn = false) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg, payloadBtn: showBtn });
	}
	Loader.hide();
}

function* setErrorPanel(errorPanel) {
	Loader.hide();
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });
}

function isDesktopDevice() {
	const ua = navigator.userAgent.toLowerCase();
	const isMobile = /android|iphone|ipad|ipod|mobile/i.test(ua);
	return !isMobile;
}

function* fetchAttempt({ payload: { attemptId, review } }) {

	if (!review) {
		try {
			const domain = "english";
			// const hostname = window.location.hostname;
			// const domain = hostname.split('.')[0];
			const courseId = yield select(getCourseId);
			const elementId = yield select(getQueryElementId);

			const orgId = localStorage.getItem('orgID');
			const loginId = localStorage.getItem('loginId');

			const proctorList = yield call(Api, {
				url: `get_proctor_details/${domain}/${courseId}/${orgId}`,
				method: 'GET',
			});

			const proctorElementIds = proctorList.map(item => item.element_id);
			localStorage.setItem('proctorList', JSON.stringify(proctorElementIds));

			console.log("Org ID:", orgId);
			console.log("Login ID:", loginId);

			const matched = proctorList?.find((item) => {
				return item.course_id == courseId &&
					item.element_id == elementId &&
					item.is_active == 1 &&
					(
						item.org_id == orgId || item.org_id == null
					);
			});

			if (matched) {
				if (isDesktopDevice()) {
					localStorage.setItem('proctorCourseId', courseId);
					RPStart({
						courseId,
						elementId,
						orgId,
						loginId,
						proctorEventName: matched.proctor_event_name,
					});
				} else {
					yield call(
						setError,
						'This test is not allowed to be taken on a mobile phone. Please use a desktop or laptop.',
						true
					);
					return;
				}
			}
		} catch (e) {
			console.log('Proctor skipped:', e);
		}

		yield put({
			type: TestPageActionTypes.SET_CURRENT_ATTEMPT_ID,
			payload: attemptId,
		});

		localStorage.removeItem('FeedbackChoicesOrder');
		localStorage.removeItem('FeedbackImageChoicesOrder');
		// yield put(push('/test'));
		window.location.href = "/test"

		return;
	}

	try {
		let isReview = '';
		if (review) isReview = '/1';
		let childToken = yield select(getChildToken);
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url: 'fetchattempt/' + attemptId + isReview,
			method: 'GET',
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				let { answers, attempt } = res.data;
				if (!!answers && !!attempt && review) {
					yield put({
						type: MyCourseActionTypes.FETCH_ATTEMPT.SUCCESS,
						payload: res.data,
					});
					yield put({
						type: TestPageActionTypes.SET_SHOW_REVIEW,
						payload: true,
					});
				}
				if (!review) {
					yield put({
						type: TestPageActionTypes.SET_CURRENT_ATTEMPT_ID,
						payload: attemptId,
					});

					if (window.location.href.includes('/test')) {
						window.location.reload();
					} else {
						localStorage.removeItem('FeedbackChoicesOrder');
						localStorage.removeItem('FeedbackImageChoicesOrder');
						yield put(push('/test'));
					}
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* fetchInstruction({
	payload: { elementId, courseId, completed, childToken },
}) {
	try {
		let userType = yield select(getUserType);
		const res = yield call(Api, {
			url:
				'fetchinstructions/' +
				courseId +
				'/' +
				(elementId || getParameterByName('element_id')),
			method: 'GET',
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				let isSpeechAvail = false;
				let {
					hide_start,
					domains,
					continue_attempt_id,
					review_attempts,
					course_id,
				} = res.data;
				review_attempts =
					Object.keys(review_attempts).length > 0 ? review_attempts[0] : 0;
				domains.forEach((domain) => {
					if (domain === 'Speaking') {
						isSpeechAvail = true;
					}
				});
				let showInstr =
					(!completed && hide_start === 0) ||
					(!!continue_attempt_id && continue_attempt_id !== 0);
				if (isSpeechAvail) {
					yield put({
						type: MyCourseActionTypes.CHECK_SPEECH.PENDING,
						payload: { showInstr, attemptId: review_attempts },
					});
				} else if (showInstr) {
					yield put({
						type: MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION,
						payload: true,
					});
				} else {
					yield put({
						type: MyCourseActionTypes.FETCH_ATTEMPT.PENDING,
						payload: {
							attemptId: review_attempts,
							review: true,
							courseId: course_id,
						},
					});
				}
				yield put({
					type: MyCourseActionTypes.FETCH_INSTRUCTIONS.SUCCESS,
					payload: {
						rawData: res.data,
						attemptRemaining: completed,
						elementId,
						courseId: course_id,
					},
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* checkSpeech({ payload: { showInstr, attemptId } }) {
	try {
		const res = yield call(Api, {
			url: 'checkspeech',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				let { speech_is_on } = res.data;
				if (speech_is_on) {
					if (showInstr) {
						yield put({
							type: MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION,
							payload: true,
						});
					} else {
						yield put({
							type: MyCourseActionTypes.FETCH_ATTEMPT.PENDING,
							payload: { attemptId, review: true },
						});
					}
				} else {
					yield put({ type: UtilsTypes.SHOW_ECHO, payload: true });
				}
				yield put({
					type: MyCourseActionTypes.SET_SPEECH_STATUS,
					payload: speech_is_on,
				});
			} else {
				yield call(setError, res.message);
				yield put({
					type: MyCourseActionTypes.SET_SPEECH_STATUS,
					payload: false,
				});
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* getCourseDetails() {
	try {
		Loader.show();
		const courseId = yield select(getCourseId);
		const elementId = yield select(getQueryElementId) ||
			getParameterByName('element_id');

		const res = yield call(Api, {
			url: 'courses/' + courseId,
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			Loader.hide();
			yield call(setError, res);
		} else {
			Loader.hide();
			if (res.code === 200) {
				Loader.hide();
				appendScript('coursedetail');
				localStorage.setItem('active_course_id', courseId);
				yield put({
					type: MyCourseActionTypes.FETCH_COURSE_DETAILS.SUCCESS,
					payload: res.data,
				});
				if (window.location.search.includes('element_id')) {
					yield put({
						type: MyCourseActionTypes.FETCH_INSTRUCTIONS.PENDING,
						payload: {
							elementId: elementId || getParameterByName('element_id'),
							courseId,
							completed: false,
						},
					});
				}
			} else {
				yield call(setError, res.message);
			}
			window.history.replaceState({}, null, '/mycourse');
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* getTaskDetails() {
	try {
		const res = yield call(Api, {
			url: 'user_tasks',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: MyCourseActionTypes.FETCH_TASK_DETAILS.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* getCallHistory() {
	try {
		const res = yield call(Api, {
			url: 'coach_call_history',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: MyCourseActionTypes.FETCH_CALL_HISTORY.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* getUpnext() {
	try {
		const res = yield call(Api, {
			url: 'mydashboard',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: ProfileTypes.SUBCRIBE_FOR_UPDATES.SUCCESS,
					payload: res.data.isSubscribe,
				});
				yield put({
					type: ProfileTypes.CHILD_STATUS,
					payload: res.data.childStatus,
				});
				yield put({
					type: MyCourseActionTypes.GET_UPNEXT.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* submitAssignment() {
	try {
		const scheduleId = yield select(getScheduleId);
		const file = yield select(getSelectedFile);
		const data = new FormData();
		data.append('task_file', file);
		data.append('schedule_id', parseInt(scheduleId, 10));

		const res = yield call(Api, {
			url: 'user_tasks',
			method: 'POST',
			headers: { 'access-token': localStorage.getItem('token') },
			data: data,
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({ type: MyCourseActionTypes.SET_SHOW_INFO, payload: true });
				yield put({ type: MyCourseActionTypes.SUBMIT_ASSIGNMENT.SUCCESS });
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* rescheduleCall() {
	try {
		const scheduleId = yield select(getCancelScheduleId);
		const reason = yield select(getReason);
		const res = yield call(Api, {
			url: 'reschedule_coach_call',
			method: 'POST',
			data: {
				schedule_id: scheduleId,
				reason_type: 'Cancel',
				reason,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				window.location.reload();
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* setGrade() {
	try {
		const grade = yield select(getGrade);
		let childToken = yield select(getChildToken);
		let activeChildId = yield select(getActiveChild);
		let children = yield select(getChildDetails);
		let userType = yield select(getUserType);
		if (!(grade || children[activeChildId].child_grade)) {
			yield call(setErrorPanel, {
				panelMsg: 'Please select your grade',
				panelClass: 'alert alert-danger',
			});
		} else {
			const res = yield call(Api, {
				url: 'change_grant',
				method: 'POST',
				data: {
					grade: grade || children[activeChildId].child_grade,
				},
				headers: {
					'access-token':
						userType === UserTypes.Parent
							? childToken
							: localStorage.getItem('token'),
				},
			});
			if (!res.status) {
				yield call(setErrorPanel, {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				});
			} else {
				if (res.code === 200) {
					Loader.hide();
					yield call(setErrorPanel, {
						panelMsg: 'Redirecting you to your course...',
						panelClass: 'alert alert-success',
					});
					yield put({
						type: UPDATE_ACTIVE_COURSE,
						payload: res.data.course_id,
					});
					window.location.reload();
				} else {
					yield call(setErrorPanel, {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					});
				}
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* generateCertificate({ payload }) {
	try {
		const course_id = yield select(getCourseId);
		const fullname = payload.name;

		const res = yield call(Api, {
			url: 'customcertificate',
			method: 'POST',
			data: {
				fullname,
				course_id,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg: res,
				panelClass: 'alert alert-danger',
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: UserProfileTypes.SET_USER_DETAILS,
					payload: { full_name: fullname },
				});
				yield put({
					type: MyCourseActionTypes.GENERATE_CERTIFICATE.SUCCESS,
					payload: res.data[0].url,
				});
				let details = JSON.parse(localStorage.getItem('userDetails'));
				if (!!details) {
					let userDetailsObj = {
						user_mail: details.user_mail,
						full_name: fullname,
						user_phone: details.user_phone,
					};
					localStorage.setItem('userDetails', JSON.stringify(userDetailsObj));
				}

				window.open(res.data[0].url);
				window.location.reload();
			} else {
				yield call(setErrorPanel, {
					panelMsg: res.message,
					panelClass: 'alert alert-danger',
				});
			}
		}
	} catch (err) {
		console.log('mycourse', err);
	}
}

function* fetchAttemptStart() {
	yield takeLatest(MyCourseActionTypes.FETCH_ATTEMPT.PENDING, fetchAttempt);
}

function* fetchInstructionStart() {
	yield takeLatest(
		MyCourseActionTypes.FETCH_INSTRUCTIONS.PENDING,
		fetchInstruction,
	);
}

function* checkSpeechStart() {
	yield takeLatest(MyCourseActionTypes.CHECK_SPEECH.PENDING, checkSpeech);
}

function* fetchCourseDetailsStart() {
	yield takeLatest(
		MyCourseActionTypes.FETCH_COURSE_DETAILS.PENDING,
		getCourseDetails,
	);
}

function* fetchTaskDetailsStart() {
	yield takeLatest(
		MyCourseActionTypes.FETCH_TASK_DETAILS.PENDING,
		getTaskDetails,
	);
}

function* fetchCallHistoryStart() {
	yield takeLatest(
		MyCourseActionTypes.FETCH_CALL_HISTORY.PENDING,
		getCallHistory,
	);
}

function* submitAssignmentStart() {
	yield takeLatest(
		MyCourseActionTypes.SUBMIT_ASSIGNMENT.PENDING,
		submitAssignment,
	);
}

function* rescheduleCallStart() {
	yield takeLatest(MyCourseActionTypes.RESCHEDULE_CALL.PENDING, rescheduleCall);
}

function* setGradeStart() {
	yield takeLatest(MyCourseActionTypes.CHANGE_GRADE.PENDING, setGrade);
}

function* generateCertificateStart() {
	yield takeLatest(
		MyCourseActionTypes.GENERATE_CERTIFICATE.PENDING,
		generateCertificate,
	);
}

function* getUpnextStart() {
	yield takeLatest(MyCourseActionTypes.GET_UPNEXT.PENDING, getUpnext);
}

export function* myCourseSagas() {
	yield all([
		call(fetchAttemptStart),
		call(fetchInstructionStart),
		call(checkSpeechStart),
		call(fetchCourseDetailsStart),
		call(fetchTaskDetailsStart),
		call(fetchCallHistoryStart),
		call(submitAssignmentStart),
		call(rescheduleCallStart),
		call(setGradeStart),
		call(generateCertificateStart),
		call(getUpnextStart),
	]);
}
